export default "__VITE_ASSET__cf754a04__"